var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.13,46.52l.34-.33a.57.57,0,0,0,0-.82h0l-8.53-8.53h18a.58.58,0,0,0,.57-.58h0v-.48a.58.58,0,0,0-.57-.57h-18l8.53-8.54a.56.56,0,0,0,0-.81h0l-.33-.34a.59.59,0,0,0-.82,0h0l-10.1,10.1a.58.58,0,0,0,0,.81h0l10.1,10.1A.56.56,0,0,0,42.13,46.52Z",
    transform: "translate(-21.77 -16.02)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.7a6bec4933423c294d25572aa053352b.svg";
export { ForwardRef as ReactComponent };